import { render, staticRenderFns } from "./r-preview-collection-dialog.vue?vue&type=template&id=2fcd6436"
import script from "./r-preview-collection-dialog.vue?vue&type=script&lang=js"
export * from "./r-preview-collection-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-preview-collection-dialog.vue?vue&type=style&index=0&id=2fcd6436&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcd6436')) {
      api.createRecord('2fcd6436', component.options)
    } else {
      api.reload('2fcd6436', component.options)
    }
    module.hot.accept("./r-preview-collection-dialog.vue?vue&type=template&id=2fcd6436", function () {
      api.rerender('2fcd6436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/preview/r-preview-collection-dialog.vue"
export default component.exports